import { c as _c } from "react/compiler-runtime";
import { SnackbarProvider } from 'notistack';
import { Slide, Box, useTheme, useMediaQuery } from '@mui/material';
import Snackbar from './Snackbar';
import Container, { UnauthorizedContainer } from './Container';
import { createContext, JSX, ReactNode, useState, use } from 'react';
import Header from './Header';
import Drawer from './Drawer';
import GlobalProvider from './Providers/GlobalProvider';
import ErrorBoundary from './ErrorBoundary';
import { useRouter } from 'next/router';
import GlobalContext from './Providers/GlobalContext';
import { NextComponentType, NextPageContext } from 'next/types';
import { navItems as allNavItems } from './navItems';
import NotFound from '@/components/NotFound';
import { useAuth0 } from '@auth0/auth0-react';
import BottomBanners from '@/components/BottomBanners/BottomBanners';
interface LayoutContextProps {
  isMobile: boolean;
  drawerOpen: boolean;
  toggleDrawer: () => void;
}
interface MainLayoutProps {
  Component: NextComponentType<NextPageContext, any, any>;
  pageProps: any;
}
export const LayoutContext = createContext<LayoutContextProps>({
  isMobile: false,
  drawerOpen: false,
  toggleDrawer: () => null
});
export default function MainLayout(props) {
  const $ = _c(22);
  const {
    user
  } = useAuth0();
  const router = useRouter();
  const theme = useTheme();
  let t0;
  if ($[0] !== theme.breakpoints) {
    t0 = theme.breakpoints.down("lg");
    $[0] = theme.breakpoints;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const matchDownLG = useMediaQuery(t0);
  const [open, setOpen] = useState(!matchDownLG);
  const [openForDownLG, setOpenForDownLG] = useState(matchDownLG);
  if (openForDownLG !== matchDownLG) {
    setOpenForDownLG(matchDownLG);
    setOpen(!matchDownLG);
  }
  let t1;
  if ($[2] !== open) {
    t1 = () => {
      setOpen(!open);
    };
    $[2] = open;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleDrawerToggle = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      vertical: "bottom",
      horizontal: "right"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleDrawerToggle || $[6] !== matchDownLG || $[7] !== open) {
    t3 = {
      isMobile: matchDownLG,
      drawerOpen: open,
      toggleDrawer: handleDrawerToggle
    };
    $[5] = handleDrawerToggle;
    $[6] = matchDownLG;
    $[7] = open;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  let t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex"
    };
    t5 = <Header />;
    t6 = <Drawer />;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
  }
  const t7 = user?.email;
  let t8;
  if ($[12] !== props) {
    t8 = <RoleAccess {...props} />;
    $[12] = props;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== router.asPath || $[15] !== t7 || $[16] !== t8) {
    t9 = <Box sx={t4}>{t5}{t6}<Container><ErrorBoundary userEmail={t7} resetKey={router.asPath}>{t8}</ErrorBoundary></Container></Box>;
    $[14] = router.asPath;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <BottomBanners />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t3 || $[20] !== t9) {
    t11 = <SnackbarProvider action={_temp} maxSnack={4} anchorOrigin={t2} TransitionComponent={Slide} autoHideDuration={6000}><GlobalProvider><LayoutContext value={t3}>{t9}{t10}</LayoutContext></GlobalProvider></SnackbarProvider>;
    $[19] = t3;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}
function _temp(key) {
  return <Snackbar id={key} />;
}
const RoleAccess = props => {
  const $ = _c(4);
  const {
    Component,
    pageProps
  } = props;
  const {
    navItems
  } = use(GlobalContext);
  const router = useRouter();
  const path = router.pathname;
  const isPartOfPages = Object.values(allNavItems).some(item => item.path === path);
  const isValidPath = navItems.map(_temp2).includes(path);
  if (isPartOfPages && !isValidPath && path !== "/") {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <NotFound />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== Component || $[2] !== pageProps) {
    t0 = <Component {...pageProps} />;
    $[1] = Component;
    $[2] = pageProps;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
export function UnauthorizedLayout(t0) {
  const $ = _c(17);
  const {
    children
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== theme.breakpoints) {
    t1 = theme.breakpoints.down("lg");
    $[0] = theme.breakpoints;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const matchDownLG = useMediaQuery(t1);
  const [open, setOpen] = useState(!matchDownLG);
  const [openForDownLG, setOpenForDownLG] = useState(matchDownLG);
  if (openForDownLG !== matchDownLG) {
    setOpenForDownLG(matchDownLG);
    setOpen(!matchDownLG);
  }
  let t2;
  if ($[2] !== open) {
    t2 = () => {
      setOpen(!open);
    };
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleDrawerToggle = t2;
  let t3;
  if ($[4] !== handleDrawerToggle || $[5] !== matchDownLG || $[6] !== open) {
    t3 = {
      isMobile: matchDownLG,
      drawerOpen: open,
      toggleDrawer: handleDrawerToggle
    };
    $[4] = handleDrawerToggle;
    $[5] = matchDownLG;
    $[6] = open;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  let t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex"
    };
    t5 = <Header unauthorized={true} />;
    t6 = <Drawer unauthorized={true} />;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children) {
    t7 = <Box sx={t4}>{t5}{t6}<UnauthorizedContainer>{children}</UnauthorizedContainer></Box>;
    $[11] = children;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <BottomBanners />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t3 || $[15] !== t7) {
    t9 = <LayoutContext value={t3}>{t7}{t8}</LayoutContext>;
    $[14] = t3;
    $[15] = t7;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}
function _temp2(item_0) {
  return item_0.path;
}